import { Button } from "@/components/ui/button";

interface AuthSubmitButtonProps {
  loading: boolean;
  isSignUp: boolean;
  disabled?: boolean;
}

export const AuthSubmitButton = ({ loading, isSignUp, disabled }: AuthSubmitButtonProps) => {
  return (
    <Button
      type="submit"
      className="w-full bg-secondary text-secondary-foreground hover:bg-secondary/80 transition-colors disabled:opacity-50"
      disabled={loading || disabled}
    >
      {loading ? "Processing..." : isSignUp ? "Get Started" : "Sign In"}
    </Button>
  );
};